import axios from "axios";
import { detectUserLocale } from "./utils/multi-language";
import { baseURL } from "./utils/constants";
import { getValidUserId } from "./utils/uuid";
import i18n from "./i18n";

const instance = axios.create({
  baseURL,
  // Cap requests so a hung/slow backend surfaces a timeout error instead of an
  // infinite "loading" spinner. The booking flow now returns promptly (BE
  // side-effects moved off the critical path), so 60s sits well above normal
  // latency while still bounding worst-case hangs.
  timeout: 60000,
});

instance.interceptors.request.use(async (config) => {
  const { community, currency } = await detectUserLocale();

  const user_id = getValidUserId();

  // Use i18n.language as the single source of truth for language,
  // ensuring API content language always matches UI label language.
  config.headers["Language"] = i18n.language || "en";
  config.headers["Community"] = community;
  config.headers["Currency"] = currency;

  if (user_id) {
    config.headers["UserId"] = user_id;
  }

  // Add ngrok-skip-browser-warning header to bypass ngrok warning page
  if (baseURL && baseURL.includes("ngrok")) {
    config.headers["ngrok-skip-browser-warning"] = "true";
  }

  return config;
});

export const unauthAxiosFetcher = async (url) => {
  try {
    const response = await instance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching data:", error); // Log the error
    throw error;
  }
};

export default instance;
